import {
  Component,
  ViewEncapsulation,
  OnInit,
  Inject,
  OnDestroy
} from '@angular/core';

import {
  FormBuilder,
  Validators,
  FormGroup,
  FormControl
} from '@angular/forms';

import {
  AuthService
} from '../../../services/auth';

import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import {
  Router
} from '@angular/router';
import {UserContext} from '../../../services/user-context';
import {ApiService} from '../../../services/api';
import {HttpParams} from '@angular/common/http';
import {BrandService} from '../../../services/brand-service/brand.service';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-login-dialog',
  encapsulation: ViewEncapsulation.None,
  templateUrl: 'login-dialog.template.html'
})

export class LoginDialogComponent implements OnInit, OnDestroy {
  public form: FormGroup;
  public formErrors = {
    email: '',
    password: ''
  };
  public loading = false;
  brandLogo = "/assets/flh8.svg";
  brandSubscription: Subscription;
  actionStyle: string;
  actionTextStyle: string;
  constructor(private authService: AuthService,
              private formBuilder: FormBuilder,
              private brandService: BrandService,
              private router: Router,
              private userContext: UserContext,
              public snackBar: MatSnackBar,
              public dialogRef: MatDialogRef<LoginDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    this.brandLogo = `https://cdn.fitsamerica.com/brand/${document.location.hostname.toLowerCase().replace(/\./g,"_")}.svg`;

    this.brandSubscription = brandService.subscribe(branding => {
      this.actionStyle = branding.action_color;
      if( branding.action_text_color ) {
        this.actionTextStyle = branding.action_text_color;
      }
    })
  }

  public ngOnInit(): void {
    this.buildForm();
  }

  public ngOnDestroy(): void {
    this.brandSubscription.unsubscribe();
  }

  public buildForm() {
    this.form = this.formBuilder.group({
      email: new FormControl('', [
        Validators.required,
        Validators.email
      ]),
      password: new FormControl('', [
        Validators.required,
        Validators.minLength(8)
      ]),
      remember: new FormControl(true)
    });
  }

  public login() {

    this.loading = true;
    this.authService.login(this.form.value.email, this.form.value.password, (err, data) => {
      if (err) {
        this.loading = false;
        this.showLoginError();
      } else {
        this.dialogRef.afterClosed().subscribe(() => {
          if ( this.userContext.isDistributor() ) {
            this.router.navigate(['distributor']);
          } else {
            this.router.navigate(['']);
          }
        });
        this.dialogRef.close({success: true});
      }
    });
  }

  private showLoginError() {
    this.snackBar.open('Email or password is invalid. Try Again.', null, {
      duration: 2000
    });
  }
}
